import { LayoutDashboard, Landmark, Bot, BookOpen, ShieldCheck } from 'lucide-react'
import { useDashboardStore } from '../../store/dashboardStore'
import { useT } from '../../hooks/useTranslation'
import { useHaptic } from '../../hooks/useHaptic'

const TAB_IDS = [
  { id: 'dashboard', Icon: LayoutDashboard },
  { id: 'portfolio', Icon: Landmark },
  { id: 'bots',      Icon: Bot },
  { id: 'trading',   Icon: BookOpen },
]

export default function BottomNav() {
  const t = useT()
  const haptic = useHaptic()

  const activeTab = useDashboardStore(s => s.activeTab)
  const setActiveTab = useDashboardStore(s => s.setActiveTab)
  const isModalOpen = useDashboardStore(s => s.isModalOpen)
  // Вкладка «Админ» видна только админу (id в ADMIN_IDS/ADMIN_ID).
  const isAdmin = useDashboardStore(s => s.isAdmin)

  // Скрываем меню, пока открыта ЛЮБАЯ модалка (isModalOpen выставляет Modal
  // при монтировании). Раньше проверяли только activeModal — модалки, открытые
  // локальным состоянием (подписка, добавить бота), не скрывали меню, и на iOS
  // навигация рисовалась поверх модалки.
  if (isModalOpen) {
    return null
  }

  const tabList = isAdmin
    ? [...TAB_IDS, { id: 'admin', Icon: ShieldCheck }]
    : TAB_IDS

  const TABS = tabList.map(tab => ({ ...tab, label: t[tab.id] || tab.id }))

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        // Высота панели 70px + безопасная зона iPhone (домашний индикатор).
        // box-sizing:border-box глобально, поэтому padding-bottom «съедает»
        // контент — если не добавить safe-area к высоте, кнопки сжимаются
        // и их иконки/подписи вылезают за нижнюю границу панели.
        height: 'calc(70px + env(safe-area-inset-bottom))',
        background: 'rgba(10,10,10,0.98)',
        borderTop: '1px solid #1A1A1A',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        zIndex: 50,
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      {TABS.map(({ id, label, Icon }) => {
        const isActive = activeTab === id
        return (
          <button
            key={id}
            onClick={() => {
              if (haptic && haptic.light) haptic.light()
              setActiveTab(id)
            }}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px',
              background: 'none',
              border: 'none',
              padding: '8px',
              cursor: 'pointer',
              flex: 1,
              minHeight: '60px'
            }}
          >
            <Icon
              size={24}
              color={isActive ? '#34D399' : '#636366'}
              strokeWidth={isActive ? 2 : 1.5}
            />
            <span
              style={{
                fontSize: '10px',
                fontWeight: '500',
                color: isActive ? '#34D399' : '#636366'
              }}
            >
              {label}
            </span>
          </button>
        )
      })}
    </div>
  )
}